import * as Yup from "yup";

export const validationSchemaHipoteca = Yup.object({
    start_date: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Fecha de inicio obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    pago_mensual: Yup.number()
    .typeError("El monto debe ser un número")
    .positive("El monto debe ser positivo")
    .when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("El monto es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    end_date: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Fecha de fin obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    compra_venta: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Contrato obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    banco: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Banco obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    titular_hipoteca: Yup.string().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Titular obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    amortizacion: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("Tabla de amortización obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    seguro_mortgage: Yup.mixed().when("isMortgaged", {
        is: true,
        then: (schema) => schema.required("El seguro es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    code: Yup.string().when("isMortgaged", {
        is: false,
        then: (schema) => schema.required("Código de confirmación obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
});